import { createRoute, useParams } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import { useGetInvestigationById } from '@/application/services/investigation.service'

import { Breadcrumb } from '@/ui/components/common/Breadcrumb'
import { investigationsRoute } from '@/ui/pages/management/investigations'

import { EditInvestigationFormSection } from './components/EditInvestigationFormSection'
import { InvestigationCommentsSection } from './components/InvestigationCommentsSection'

export const investigationsEditRoute = createRoute({
  getParentRoute: () => investigationsRoute,
  path: '$id/edit',
  component: EditInvestigationPage,
})

export function EditInvestigationPage() {
  const { id } = useParams({ strict: false })
  const { t } = useTranslation()
  const investigationId = id ?? ''
  // We only fetch here to get the investigation name for the breadcrumb;
  // the section also fetches the investigation but it is de-duplicated by
  // React-Query's cache so this is essentially free.
  const { data: investigation } = useGetInvestigationById(investigationId)

  return (
    <div className="space-y-6">
      <Breadcrumb
        items={[
          { label: t('admin.nav_investigations'), href: '/manage/investigations' },
          {
            label: investigation?.name ?? '…',
            href: `/manage/investigations/${investigationId}/leads`,
          },
          { label: t('admin.form_edit_title') },
        ]}
      />

      <EditInvestigationFormSection investigationId={investigationId} />
      <InvestigationCommentsSection investigationId={investigationId} />
    </div>
  )
}
